module.exports = __webpack_public_path__ + "static/media/fees.a99ad436.svg";